import { render, staticRenderFns } from "./goodsOtherInfo.vue?vue&type=template&id=54dd293b"
import script from "./goodsOtherInfo.vue?vue&type=script&lang=js"
export * from "./goodsOtherInfo.vue?vue&type=script&lang=js"
import style0 from "./goodsOtherInfo.vue?vue&type=style&index=0&id=54dd293b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports